import request from '../../../axios';

export const getSponsorDetail = async (guid: string) => {
  const {data}: {data: getSponsorDetailResponse} = await request.get(
    `/api/v2/notification/sponsor/${guid}`,
  );
  return data;
};
